import {
  FETCH_SALES_REPORT_SUCCESS,
  FETCH_CONSIGNER_OPTIONS_SUCCESS,
  FETCH_MONTH_OPTIONS_SUCCESS,
  FETCH_SAVED_REPORTS,
  FETCH_SAVED_REPORTS_SUCCESS,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER
} from "../constants/ActionTypes";

const INIT_STATE = {
  loader: true,
  noContentFoundMessage: "No data found",
  filters: {
    consigner: "",
    month: ""
  },
  consignerOptions: [],
  monthOptions: [],
  salesReportData: {
    lines: [],
    pageInfo: {
      page: 1,
      offset: 0,
      total: 0,
      previousPage: null,
      nextPage: null
    },
  },
  savedReportsData: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_SALES_REPORT_SUCCESS: {
      return {
        ...state,
        loader: false,
        salesReportData: action.payload
      };
    }
    case FETCH_CONSIGNER_OPTIONS_SUCCESS: {
      return {
        ...state,
        consignerOptions: action.payload
      };
    }
    case FETCH_MONTH_OPTIONS_SUCCESS: {
      return {
        ...state,
        monthOptions: action.payload
      };
    }
    case FETCH_SAVED_REPORTS: {
      return {
        ...state,
        loader: true,
        savedReportsData: []
      };
    }
    case FETCH_SAVED_REPORTS_SUCCESS: {
      return {
        ...state,
        loader: false,
        savedReportsData: action.payload
      };
    }


    case ON_SHOW_LOADER: {
      return {
          ...state,
          loader: true
      }
    }
    case ON_HIDE_LOADER: {
        return {
            ...state,
            loader: false
        }
    }
    default:
        return state;
    }
};
